import axios from "axios";
import https from "https";
import customProtocolCheck from "custom-protocol-check";

export default class NexSignClientApi {
  constructor() {
    this.activeUrl = undefined;
  }

  async init() {
    var currentVersion = await this.getVersion();
    var latestVersion = await axios.get(`/api/systemsetting/module/0ceb612e-77bc-4b0e-9cd9-c02ef891fba7/public?keys=SignClientVersion&keys=SignClientURL`);
    
    if (parseFloat(latestVersion.data.SignClientVersion) > parseFloat(currentVersion)){
      throw new Error("CLIENT_NOT_LATEST");
    }

    if (!this.activeUrl) {
      const exist = await this.checkProtocol();
      if (!exist) {
        throw new Error("CLIENT_NOT_INSTALLED");
      } else {
        throw new Error("CLIENT_NOT_STARTED");
      }
    }
  }

  checkProtocol() {
    return new Promise((res) => {
      customProtocolCheck(
        "nexsign://",
        () => res(false),
        () => res(true)
      );
    });
  }

  // async getVersion() {
  //   let url1 = process.env.VUE_APP_API_URL_NexSignClientModule_1;
  //   let url2 = process.env.VUE_APP_API_URL_NexSignClientModule_2;
  //   let url3 = process.env.VUE_APP_API_URL_NexSignClientModule_3;

  //   const checkConnectionTimeout = 1000;
  //   const urls = [url1, url2, url3];
  //   for (const url of urls) {
  //     try {
  //       const res = await axios.get(url + "/nexify/nexsign/version", {
  //         timeout: checkConnectionTimeout / urls.length,
  //       });
  //       this.activeUrl = url;
  //       return res.data.version;
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  //   return undefined;
  // }
  async getVersion() {
    let url1 = process.env.VUE_APP_API_URL_NexSignClientModule_1;
    let url2 = process.env.VUE_APP_API_URL_NexSignClientModule_2;
    let url3 = process.env.VUE_APP_API_URL_NexSignClientModule_3;

    const urls = [url1, url2, url3];
    console.log("getVersion")
    for (const url of urls) {
      try {
        const res = await axios.get(url + '/nexify/nexsign/version');
        this.activeUrl = url;
        return res.data.version;
      } catch (err) {
        console.log(err);
      }
    }

    customProtocolCheck(
      'nexsign://',
      () => res(false),
      () => res(true)
    );

    throw new Error('CLIENT_NOT_STARTED');
  }

  getDownloadUrl() {
    let clientVersion = process.env.REACT_APP_NEXSIGN_CLIENT_VERSION;
    let downloadUrl = process.env.REACT_APP_NEXSIGN_CLIENT_DOWNLOAD_URL;
    return downloadUrl.replace("{version}", clientVersion);
  }

  async p12SignPdf(digest) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/p12/sign/pdf",
      { digest }
    );
    return sign.data;
  }

  async p12SignDoc(hashCode) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/p12/sign/doc",
      { hashCode }
    );
    return sign.data;
  }

  async p12SignPdfBatch(digests) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/p12/sign/pdfs",
      { digests }
    );
    return sign.data;
  }

  async p12SignDocBatch(hashCodes) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/p12/sign/docs",
      { hashCodes }
    );
    return sign.data;
  }

  async usbSignPdfBatch(alias, digests) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/usb/sign/pdfs",
      { alias, digests }
    );
    return sign.data;
  }

  async usbSignDocBatch(alias, hashCodes) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/usb/sign/docs",
      { alias, hashCodes }
    );
    return sign.data;
  }

  async p12SignIdentity(identity) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/p12/sign/identity",
      { identity: identity }
    );
    return sign.data;
  }

  async getUsbCerts() {
    const certs = await axios.get(
      this.activeUrl + "/nexify/nexsign/usb/certs",
      { timeout: 5 * 60 * 1000 }
    );
    return certs.data;
  }

  async usbSignPdf(alias, digest) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/usb/sign/pdf",
      { alias: alias, digest: digest }
    );
    return sign.data;
  }

  async usbSignDoc(alias, hashCode) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/usb/sign/doc",
      { alias: alias, hashCode: hashCode }
    );
    return sign.data;
  }

  async usbSignIdentity(alias, identity) {
    const sign = await this._post(
      this.activeUrl + "/nexify/nexsign/usb/sign/identity",
      { alias: alias, identity: identity }
    );
    return sign.data;
  }

  async _post(url, req) {
    return await axios.post(url, req, {
      httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      timeout: 5 * 60 * 1000,
    });
  }
}
